<template>
  <div class="value-props-page">
    <div
      id="signUpForm"
      class="section-image-background-wrapper section-background-image height-unset bg-green"
      v-if="!$route.query.submitted"
    >
      <div class="section-background hide-md">
        <img class="width-100 height-100 object-fit-cover" src="../../assets/img/value-props/retailers-1.png" />
      </div>
      <div class="section-content">
        <div class="grid-wrapper grid-wrapper--col__2 pt-70 pb-70 pt-30-sm container">
          <div></div>
          <div>
            <div class="pl-80 pl-0-md pr-0-md">
              <sign-up-form
                v-bind:hiddenField="$route.name"
                applicationType="brand"
                :customAssortment="false"
                btn-copy="Apply Now"
                class="ml-100 retailer-signup--form"
              >
              </sign-up-form>
            </div>
          </div>
        </div>
      </div>
    </div>

    <section class="relative mb-0" v-if="$route.query.submitted" id="signup_form_submitted">
      <div class="bg-green">
        <div class="container pb-40 pt-30 pb-130 text-center">
          <h1 class="mt-90 mt-60-sm px-60 px-0-sm">
            Thanks for applying! We're reviewing applications on a rolling basis and will be in touch soon.
          </h1>
        </div>
      </div>
    </section>

    <div class="page-wrapper page-wrapper--white pb-80-sm pt-50-sm">
      <div class="container text-center">
        <h1 class="text-center margin-bottom-100 mb-50-sm">How it works</h1>
        <div class="grid-wrapper grid-wrapper--col__3 grid-wrapper--column-border">
          <div class="value-props-benefit pb-80-sm">
            <div>
              <img :src="model.icon1" :style="{ width: `${model.iconWidth1}px` }" />
            </div>
            <h4 class="margin-bottom-20 display-block" v-html="model.header_1"></h4>
            <p class="font-size-20 font-size-12-sm">{{ model.text_1 }}</p>
          </div>
          <div class="value-props-benefit pb-80-sm">
            <div>
              <img :src="model.icon2" :style="{ width: `${model.iconWidth2}px` }" />
            </div>
            <h4 class="margin-bottom-20 display-block" v-html="model.header_2"></h4>
            <p class="font-size-20 font-size-12-sm">{{ model.text_2 }}</p>
          </div>
          <div class="value-props-benefit">
            <div>
              <img :src="model.icon3" :style="{ width: `${model.iconWidth3}px` }" />
            </div>
            <h4 class="margin-bottom-20 display-block" v-html="model.header_3"></h4>
            <p class="font-size-20 font-size-12-sm">{{ model.text_3 }}</p>
          </div>
        </div>
      </div>
    </div>
    <!-- hero cta -->
    <section class="hero-image hero-image--brand-cta">
      <div class="hero-text--cta">
        <h1 class="letter-spacing-02 font-size-38-sm line-height-1-3">
          We’re Bulletin, your <br />merchant on-demand. <br />Ready to get started?
        </h1>
        <div class="button-wrapper mt-20">
          <bulletin-button v-on:click="scrollToID('signUpForm')" class="width-380 width-100-sm">
            Apply now
          </bulletin-button>
        </div>
      </div>
    </section>
    <!-- end hero cta -->

    <section>
      <img
        src="../../assets/img/value-props/brand-1-1.jpg"
        class="hide show-md width-100 max-height-500 max-height-320-sm object-fit-cover"
      />
      <div class="section-image-background-wrapper section-image-background">
        <img src="../../assets/img/value-props/brand-1-1.jpg" class="hide-md" />
        <div class="section-background"></div>
        <div class="section-content pb-120-sm">
          <div class="grid-wrapper grid-wrapper--col__2">
            <div></div>
            <div class="text-left">
              <h4 class="pl-60 pr-60 pr-30-sm pl-30-sm mt-50 mt-30-sm">Marketing Support</h4>
              <div class="px-40">
                <h4 class="font-size-30 font-size-24-sm uppercase text-center pt-140 pt-50-sm px-30">
                  We pitch your product
                </h4>
                <p class="font-size-20 font-size-12-sm pt-40 pt-20-sm w-100 text-center">
                  With our custom assortment program, Bulletin helps retailers explore and shop new price points,
                  product categories and brands. That means we actively pitch your product to retailers who sign up.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>

      <img
        src="../../assets/img/value-props/brand-1-2.jpg"
        class="hide show-md width-100 max-height-500 max-height-320-sm object-fit-cover"
      />
      <div class="section-image-background-wrapper section-background-image">
        <img src="../../assets/img/value-props/brand-1-2.jpg" class="hide-md" />
        <div class="section-background"></div>
        <div class="section-content pb-120-sm">
          <div class="grid-wrapper grid-wrapper--col__2">
            <div class="text-right">
              <h4 class="pl-60 pr-60 pr-30-sm pl-30-sm mt-50 mt-30-sm">premium stores</h4>
              <div class="px-40">
                <h4 class="font-size-30 font-size-24-sm uppercase text-center pt-140 pt-50-sm px-30">
                  We vet our retailers
                </h4>
                <p class="font-size-20 font-size-12-sm pt-40 pt-20-sm w-100 text-center">
                  You’re on a wholesale marketplace to get quality wholesale orders — duh! That’s why unlike other
                  marketplaces, we require every retailer to produce a valid reseller ID before buying.
                </p>
              </div>
            </div>
            <div></div>
          </div>
        </div>
      </div>

      <img
        src="../../assets/img/value-props/1202.png"
        class="hide show-md width-100 max-height-500 max-height-320-sm object-fit-cover"
      />
      <div class="section-image-background-wrapper section-image-background">
        <img src="../../assets/img/value-props/1202.png" class="hide-md" />
        <div class="section-background"></div>
        <div class="section-content pb-120-sm">
          <div class="grid-wrapper grid-wrapper--col__2">
            <div></div>
            <div class="text-left">
              <h4 class="pl-60 pr-60 pr-30-sm pl-30-sm mt-50 mt-30-sm">Account Control</h4>
              <div class="px-40">
                <h4 class="font-size-30 font-size-24-sm uppercase text-center pt-140 pt-50-sm px-30">
                  We put you in the driver’s seat
                </h4>
                <p class="font-size-20 font-size-12-sm pt-40 pt-20-sm w-100 text-center">
                  We abide by your MOV, MOQ, and case pack requirements, and you can always reject a suborder. You
                  decide where your product goes, and who gets to sell it.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>

      <img
        src="../../assets/img/value-props/brand-1-3.jpg"
        class="hide show-md width-100 max-height-500 max-height-320-sm object-fit-cover"
      />
      <div class="section-image-background-wrapper section-background-image">
        <img src="../../assets/img/value-props/brand-1-3.jpg" class="hide-md" />
        <div class="section-background"></div>
        <div class="section-content pb-120-sm">
          <div class="grid-wrapper grid-wrapper--col__2">
            <div class="text-right">
              <h4 class="pl-60 pr-60 pr-30-sm pl-30-sm mt-50 mt-30-sm">Order Management</h4>
              <div class="px-40">
                <h4 class="font-size-30 font-size-24-sm uppercase text-center pt-140 pt-50-sm px-30">
                  We charge 0% for existing stockists
                </h4>
                <p class="font-size-20 font-size-12-sm pt-40 pt-20-sm w-100 text-center">
                  Want to streamline your wholesale business with existing stockists? Invite them to Bulletin and we’ll
                  nix our commission.
                </p>
              </div>
            </div>
            <div></div>
          </div>
        </div>
      </div>

      <img
        src="../../assets/img/value-props/brands-5.jpg"
        class="hide show-md width-100 max-height-500 max-height-320-sm object-fit-cover"
      />
      <div class="section-image-background-wrapper section-image-background">
        <img src="../../assets/img/value-props/brands-5.jpg" class="hide-md" />
        <div class="section-background"></div>
        <div class="section-content pb-120-sm">
          <div class="grid-wrapper grid-wrapper--col__2">
            <div></div>
            <div class="text-left">
              <h4 class="pl-60 pr-60 pr-30-sm pl-30-sm mt-50 mt-30-sm">Guaranteed sale</h4>
              <div class="px-40">
                <h4 class="font-size-30 font-size-24-sm uppercase text-center pt-140 pt-50-sm px-30">
                  We finance the risk
                </h4>
                <p class="font-size-20 font-size-12-sm pt-40 w-100 text-center">
                  We help retailers discover and test products that actually sell. We pay our brands with net-15 terms
                  so that you never have to chase down payments and will always get paid on time. All you have to do is
                  focus on making knockout products and growing your wholesale business.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <section>
      <div
        class="
          text-left
          mr-40
          ml-40
          mr-30-sm
          ml-30-sm
          padding-top-100 padding-bottom-130
          pt-80-sm
          pb-80-sm
          border-bottom
        "
      >
        <div class="quote container--large pr-0-sm pl-0-sm">
          <div className="quote--thumbnail">
            <img
              @click="redirect('1d3fc405-9e37-40b3-89f7-75bb7f409cdc')"
              src="@/assets/img/value-props/300x300/1.png"
              class="pointer"
            />
          </div>
          <div class="quote--block">
            <blockquote class="font-size-28 font-size-16-sm" style="line-height: 1.64">
              “Using Bulletin has given me the opportunity to reach so many cool stores I wouldn't have known about
              otherwise. There is one store in particular that I definitely cold emailed twice and they never responded
              but after finding me on the Bulletin platform they placed an order! I think being on the platform granted
              my brand an unspoken level of credibility that a cold email never could.”
            </blockquote>
            <div>
              <h4 @click="redirect('1d3fc405-9e37-40b3-89f7-75bb7f409cdc')" class="mb-5 mt-40 pointer">
                A Shop of Things
              </h4>
              <p class="block mb-20">Accessories</p>
              <h4 class="block uppercase">Mia</h4>
              <p class="block">Founder</p>
            </div>
          </div>
        </div>
      </div>
      <div
        class="
          text-left
          mr-40
          ml-40
          mr-30-sm
          ml-30-sm
          padding-top-100 padding-bottom-130
          pt-80-sm
          pb-80-sm
          border-bottom
        "
      >
        <div class="quote container--large pr-0-sm pl-0-sm">
          <div className="quote--thumbnail">
            <img
              @click="redirect('4191a847-330c-4866-ac56-de4082d8629e')"
              src="@/assets/img/value-props/300x300/2.png"
              class="pointer"
            />
          </div>
          <div class="quote--block">
            <blockquote class="font-size-28 font-size-16-sm" style="line-height: 1.64">
              “Managing multiple orders via the Bulletin platform has been super easy! Having an email notifying you
              that an order has come thru and then going on to the platform saying the order is pending until you
              approve the order. Having the 3 stages from pending to fulfillment in progress to shipped is a great way
              for me to remain organized. Also knowing the exact payout date is great for accounting and cash flow
              purposes.”
            </blockquote>
            <h4 @click="redirect('4191a847-330c-4866-ac56-de4082d8629e')" class="mb-5 mt-40 pointer">The YES Bar</h4>
            <p class="block mb-20">Pantry</p>
            <h4 class="block uppercase">Brennan Spreitzer</h4>
            <p class="block">CEO</p>
          </div>
        </div>
      </div>
      <div
        class="
          text-left
          mr-40
          ml-40
          mr-30-sm
          ml-30-sm
          padding-top-100 padding-bottom-130
          pt-80-sm
          pb-80-sm
          border-bottom
        "
      >
        <div class="quote container--large pr-0-sm pl-0-sm">
          <div className="quote--thumbnail">
            <img
              @click="redirect('29ee19b8-3f97-4682-bd64-94105a77ea6f')"
              src="@/assets/img/value-props/300x300/3.png"
              class="pointer"
            />
          </div>
          <div class="quote--block">
            <blockquote class="font-size-28 font-size-16-sm" style="line-height: 1.64">
              “My brand is performing well and is generating more sales than I expected this early on. Unlike other
              platforms that feel overly saturated with brands Bulletin has curated a very fresh, high quality, group of
              brands and I think that is helping to drive up sales.”
            </blockquote>
            <h4 @click="redirect('29ee19b8-3f97-4682-bd64-94105a77ea6f')" class="mb-5 mt-40 pointer">KB Paperie</h4>
            <p class="block mb-20">Stationery</p>
            <h4 class="block uppercase">Kelly Blose</h4>
            <p class="block">Owner</p>
          </div>
        </div>
      </div>
      <div
        class="
          text-left
          mr-40
          ml-40
          mr-30-sm
          ml-30-sm
          padding-top-100 padding-bottom-130
          pt-80-sm
          pb-80-sm
          border-bottom
        "
      >
        <div class="quote container--large pr-0-sm pl-0-sm">
          <div className="quote--thumbnail">
            <img
              @click="redirect('b533048d-9858-4ecc-a5dc-20a14481664b')"
              src="@/assets/img/value-props/300x300/4.png"
              class="pointer"
            />
          </div>
          <div class="quote--block">
            <blockquote class="font-size-28 font-size-16-sm" style="line-height: 1.64">
              “Bulletin’s maker-friendly commission rate and payment terms are a huge bonus to a small business. It’s
              exciting to see an order come through from a new retailer and know you’ll keep most of the sale…. The
              stockists who have found me on Bulletin have felt like a natural fit on the whole — they’re the type of
              shops I’m really excited to see an order from. I’ve also received orders from types of shops I wouldn’t
              have considered reaching out to on my own.”
            </blockquote>
            <h4 @click="redirect('b533048d-9858-4ecc-a5dc-20a14481664b')" class="mb-5 mt-40 pointer">
              Boss Dotty Paper Co.
            </h4>
            <p class="block mb-20">Stationery</p>
            <h4 class="block uppercase">Theresa Berens</h4>
            <p class="block">Owner & Illustrator</p>
          </div>
        </div>
      </div>
      <div
        class="
          text-left
          mr-40
          ml-40
          mr-30-sm
          ml-30-sm
          padding-top-100 padding-bottom-130
          pt-80-sm
          pb-80-sm
          border-bottom
        "
      >
        <div class="quote container--large pr-0-sm pl-0-sm">
          <div className="quote--thumbnail">
            <img
              @click="redirect('b6e4dd8c-c961-4a88-8568-a50b0deab66c')"
              src="@/assets/img/value-props/300x300/5.png"
              class="pointer"
            />
          </div>
          <div class="quote--block">
            <blockquote class="font-size-28 font-size-16-sm" style="line-height: 1.64">
              “Bulletin has provided us with a really easy to use and streamlined wholesale platform! It is easy to view
              and manage all of our orders and it is a huge bonus to not worry about invoicing the customer!”
            </blockquote>
            <div>
              <h4 @click="redirect('b6e4dd8c-c961-4a88-8568-a50b0deab66c')" class="mb-5 mt-40 pointer">
                MacBailey Candle Co
              </h4>
              <p class="block mb-20">Candles</p>
              <h4 class="block uppercase">Clara Bailey</h4>
              <p class="block">Owner</p>
            </div>
          </div>
        </div>
      </div>
      <div
        class="
          text-left
          mr-40
          ml-40
          mr-30-sm
          ml-30-sm
          padding-top-100 padding-bottom-130
          pt-80-sm
          pb-80-sm
          border-bottom
        "
      >
        <div class="quote container--large pr-0-sm pl-0-sm">
          <div className="quote--thumbnail">
            <img
              @click="redirect('fd9a6bdb-4ca5-4e12-a2b8-7db72f8a3e6c')"
              src="@/assets/img/value-props/300x300/6.png"
              class="pointer"
            />
          </div>
          <div class="quote--block">
            <blockquote class="font-size-28 font-size-16-sm" style="line-height: 1.64">
              “We really love how easy it is to add new products to our selection on Bulletin, rather than having to go
              through a long approval process. Whenever we need to update product details or assets, we are able to do
              so with ease.”
            </blockquote>
            <div>
              <h4 @click="redirect('fd9a6bdb-4ca5-4e12-a2b8-7db72f8a3e6c')" class="mb-5 mt-40 pointer">FUR</h4>
              <p class="block mb-20">Beauty</p>
              <h4 class="block uppercase">Laura Schubert</h4>
              <p class="block">CEO and cofounder</p>
            </div>
          </div>
        </div>
      </div>
      <div class="text-left mr-40 ml-40 mr-30-sm ml-30-sm padding-top-100 padding-bottom-130 pt-80-sm pb-80-sm">
        <div class="quote container--large pr-0-sm pl-0-sm">
          <div className="quote--thumbnail">
            <img
              @click="redirect('104b9430-ab19-488b-ba9f-161bf3bf8df6')"
              src="@/assets/img/value-props/300x300/7.png"
              class="pointer"
            />
          </div>
          <div class="quote--block">
            <blockquote class="font-size-28 font-size-16-sm" style="line-height: 1.64">
              “I totally would (recommend Bulletin). It’s a great opportunity to grow your business and income while
              being on a platform that is more curated than platforms like Faire! I feel that customers buying from
              Bulletin know exactly what kind of products they are looking for and are touching a similar audience than
              mine.”
            </blockquote>
            <div>
              <h4 @click="redirect('104b9430-ab19-488b-ba9f-161bf3bf8df6')" class="mb-5 mt-40 pointer">Made Au Gold</h4>
              <p class="block mb-20">Novelty/Gifts</p>
              <h4 class="block uppercase">Lea Ridenou</h4>
              <p class="block">Owner</p>
            </div>
          </div>
        </div>
      </div>
    </section>

    <div class="page-wrapper page-wrapper--grey pt-130 pb-130 pt-50-sm pb-80-sm">
      <div class="container">
        <div class="apply--wrapper text-center">
          <h1 class="letter-spacing-02 font-size-38-sm line-height-1-3 mb-40">Ready to get started?</h1>
          <div class="button-wrapper">
            <bulletin-button v-on:click="scrollToID('signUpForm')" class="third-width width-100-sm"
              >Apply now</bulletin-button
            >
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import iconArrow from "../../assets/img/icon-arrow.svg";
import iconGraph2 from "../../assets/img/icon-graph2.svg";
import iconAssortment from "../../assets/img/icon-assortment.svg";

import SignUpForm from "./../../components/shared/signUpForm/signUpForm.vue";

export default {
  components: {
    SignUpForm,
  },
  data() {
    return {
      activeView: null,
      model: {},
      brand: {
        icon1: iconArrow,
        iconWidth1: 48,
        header_1: "Wholesale Orders <br/> in a Snap",
        text_1: "Access our network of vetted retailers and get suborders straight to your inbox.",
        icon2: iconGraph2,
        iconWidth2: 110,
        header_2: "Quick n’ Easy <br/> Setup ",
        text_2: "We'll handle all product onboarding, shipment tracking and customer service with the retailer.",
        icon3: iconAssortment,
        iconWidth3: 40,
        header_3: "Fair pricing <br/><br/>",
        text_3: "We take a low 10-15% commission on orders and pay within 15 days of fulfillment.",
      },
    };
  },

  beforeMount() {
    this.activeView = "brand";
    this.updateModel();
  },
  methods: {
    redirect,
    scrollToID: (target) => {
      document.getElementById(target).scrollIntoView({ behavior: "smooth" });
    },
    updateModel: updateModel,
  },

  watch: {
    "$route.params.view": function (val) {
      this.activeView = val;
      this.updateModel();
    },
  },
};

function updateModel() {
  if (this.activeView === "brand") {
    this.model = this.brand;
  } else if (this.activeView === "retailer") {
    this.model = this.retailer;
  } else if (this.activeView === "assortment") {
    this.model = this.assortment;
  }
}

function openUnregisteredModal() {
  // this.$eventBus.$emit('showQuickShopModalUnregistered', null);
  this.$eventBus.$emit("apply-modal-unregistered", null);
}

function redirect(url) {
  this.$router.push({ name: "brand-bio", params: { brandUrl: url } });
}
</script>

<style lang="scss" scoped>
@import "../../assets/sass/base/vars.scss";
@import "../../assets/sass/base/helpers.scss";
@import "./valueProps.scss";
</style>
